var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Типы расходов исполнителя",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "WorkerCostTypeAdd",
      "route-edit": "WorkerCostTypeEdit",
      "route-view": "WorkerCostTypeView",
      "route-path": "/worker_cost_types",
      "can-edit": _vm.canEditWorkerCostTypeCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b307ee8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b307ee8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkerCostTypes/WorkerCostTypes.vue
// module id = null
// module chunks = 